export default "__VITE_ASSET__vly9TH9i__"